



















































































































































































import Vue from 'vue'
import { mapState } from 'vuex'
import { Project } from '@/interfaces'

interface Rubrique {
  children?: Rubrique
  label: string
  value: null | string
}

export default Vue.extend({
  props: {
    project: {
      type: Object as () => Project,
      required: true,
      default: () => {
        return {
          id: null,
        }
      },
    },
    items: {
      type: Array,
      required: false,
      default: () => {
        return []
      },
    },
  },
  data() {
    return {
      busy: false,
      viewportWidth: 0,
      formModel: {
        rubriqueKey: [null] as unknown,
        place: null as null | string,
        location: null as null | string,
        position: null as null | number,
        value1: null as null | number | string,
        value2: null as null | number | string,
        value3: null as null | number | string,
        highlight: null as null | boolean | string,
      },
      deleteRubrique: false,
      deletePlace: false,
      deleteLocation: false,
      deletePosition: false,
      deleteValue1: false,
      deleteValue2: false,
      deleteValue3: false,
      deleteHighlight: false,
      rubriques: [] as Rubrique[],
    }
  },
  computed: {
    ...mapState(['user']),
  },
  mounted() {
    if (this.user) {
      this.rubriques = this.user.client.config.rubriques
      this.rubriques.push({
        value: null,
        label: 'Pas de changement',
      })
    }

    this.viewportWidth = window.innerWidth

    window.addEventListener('resize', this.onResize)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.onResize)
  },
  methods: {
    onResize() {
      this.viewportWidth = window.innerWidth
    },
    closeModal() {
      this.formModel = {
        rubriqueKey: [null],
        place: null,
        location: null,
        position: null,
        value1: null,
        value2: null,
        value3: null,
        highlight: null,
      }

      this.deleteRubrique = false
      this.deletePlace = false
      this.deletePosition = false
      this.deleteLocation = false
      this.deleteValue1 = false
      this.deleteValue2 = false
      this.deleteValue3 = false
      this.deleteHighlight = false

      this.$emit('closeEditModal')
    },
    submit() {
      let data = {
        ...this.formModel,
      }

      // Position
      if (this.deletePosition == true) {
        data.position = 0
      } else {
        data.position = this.formModel.position
      }

      // Place
      if (this.deletePlace == true) {
        data.place = 'NULL'
      } else {
        data.place = this.formModel.place
      }

      // Location
      if (this.deleteLocation == true) {
        data.location = 'NULL'
      } else {
        data.location = this.formModel.location
      }

      // Rubrique
      if (this.deleteRubrique == true) {
        data.rubriqueKey = 'NULL'
      } else {
        if (Array.isArray(this.formModel.rubriqueKey)) {
          data.rubriqueKey = this.formModel.rubriqueKey[this.formModel.rubriqueKey.length - 1]
        } else {
          data.rubriqueKey = this.formModel.rubriqueKey
        }
      }

      // Estimations : champ vide = pas de changement, 0 reste une valeur valide (Mémoire)
      const estimations = [
        { key: 'value1', deleted: this.deleteValue1 },
        { key: 'value2', deleted: this.deleteValue2 },
        { key: 'value3', deleted: this.deleteValue3 },
      ] as const
      estimations.forEach(({ key, deleted }) => {
        const value = this.formModel[key]
        if (deleted) {
          data[key] = 'NULL'
        } else {
          data[key] = value === null || value === '' ? null : value
        }
      })

      // Lot phare
      data.highlight = this.deleteHighlight ? 'NULL' : this.formModel.highlight

      this.busy = true
      this.$api
        .put(`/inventory/${this.project.id}/items/edit`, {
          items: this.items,
          data,
        })
        .then(() => {
          this.$notify({
            type: 'success',
            title: 'Succès',
            message: 'Opération réalisée avec succès !',
          })

          this.closeModal()
        })
        .finally(() => {
          this.busy = false
        })
    },
    filterCategory(node: Record<string, string>, keyword: string) {
      return node.label.toLowerCase().includes(keyword.toLowerCase())
    },
  },
})
